import { useState, useEffect } from 'react';
import Navigation from '../../../../components/layout/Navigation';
import Footer from '../../../../components/layout/Footer';
import HeroSection from './components/HeroSection';
import DefinitionSection from './components/DefinitionSection';
import ApproachSection from './components/ApproachSection';
import WhyChooseSection from './components/WhyChooseSection';
import BenefitsSection from './components/BenefitsSection';
import CTASection from './components/CTASection';

export default function BrandingPage() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-purple-800 to-pink-800 text-white overflow-x-hidden">
      <Navigation />
      <main>
        <HeroSection scrollY={scrollY} />
        <DefinitionSection />
        <ApproachSection />
        <WhyChooseSection />
        <BenefitsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}